import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const knightEldConfig: TSPConfig = {
  key: 'knighteld',
  name: 'KnightELD',
  category: TSPCategory.API_KEY,
  helpText:
    '1. Log in to https://knighteld.com/ and open the Access Keys tab.\n2. Click the + button, then enable Vehicles by checking allowed under Read permissions.\n3. Create the access key and copy the value into the field below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default knightEldConfig;
